import { createApi } from '@reduxjs/toolkit/query/react';
import { FetchBaseQueryWithHeaderToken } from './FetchBaseQuery';

export const ContractTypeApi = createApi({
   reducerPath: 'ContractTypeApi',
   baseQuery: FetchBaseQueryWithHeaderToken,
   tagTypes: ['ContractType', 'ContractTypeList'],
   endpoints: (builder) => ({
      getPaginatedContractTypes: builder.query({
         query: ({ limit = 10, page = 1 }) => ({
            url: `/contract-type/pagination?limit=${limit}&page=${page}`,
            method: 'GET',
         }),
         providesTags: ['ContractTypeList'],
      }),
      // Get all contract types
      getAllContractTypes: builder.query({
         query: () => ({
            url: '/contract-type/list',
            method: 'GET',
         }),
         providesTags: ['ContractTypeList'],
      }),

      // Get active contract types
      getActiveContractTypes: builder.query({
         query: () => ({
            url: '/contract-type/active',
            method: 'GET',
         }),
         providesTags: ['ContractTypeList'],
      }),

      // Get contract type by ID
      getContractTypeById: builder.query({
         query: (id) => ({
            url: `/contract-type/view/${id}`,
            method: 'GET',
         }),
         providesTags: (result, error, id) => [{ type: 'ContractType', id }],
      }),

      // Create contract type
      createContractType: builder.mutation({
         query: (data) => ({
            url: '/contract-type/create',
            method: 'POST',
            body: data,
         }),
         invalidatesTags: ['ContractTypeList'],
      }),

      // Update contract type
      updateContractType: builder.mutation({
         query: ({ id, data }) => ({
            url: `/contract-type/update/${id}`,
            method: 'PUT',
            body: data,
         }),
         invalidatesTags: (result, error, { id }) => [
            'ContractTypeList',
            { type: 'ContractType', id },
         ],
      }),

      // Delete contract type
      deleteContractType: builder.mutation({
         query: (id) => ({
            url: `/contract-type/delete/${id}`,
            method: 'DELETE',
         }),
         invalidatesTags: ['ContractTypeList'],
      }),

      // Toggle active status
      toggleContractTypeStatus: builder.mutation({
         query: (id) => ({
            url: `/contract-type/toggle-active/${id}`,
            method: 'PATCH',
         }),
         invalidatesTags: (result, error, id) => ['ContractTypeList', { type: 'ContractType', id }],
      }),
   }),
});

export const {
   useGetPaginatedContractTypesQuery,
   useGetAllContractTypesQuery,
   useGetActiveContractTypesQuery,
   useGetContractTypeByIdQuery,
   useCreateContractTypeMutation,
   useUpdateContractTypeMutation,
   useDeleteContractTypeMutation,
   useToggleContractTypeStatusMutation,
} = ContractTypeApi;
